import {
  BriefcaseFill,
  EnvelopeAtFill,
  StarFill,
  GeoAltFill,
  TelephoneInboundFill,
  ImageFill,
  Send,
  Star,
} from "react-bootstrap-icons";
import AddRatings from "./modals/AddRatings";
import AddMessage from "./modals/AddMessage";
import { useState } from "react";
import DisplayImages from "./modals/DisplayImages";

const BusinessCard = ({
  businessName,
  secondParty,
  isModal,
  businessCategory,
  businessEmailAddress,
  grabEmail,
  address,
  city,
  state,
  phone,
  photo,
  ratingScore,
  showModal,
  handleClose,
  handleShow,
  showMessageModal,
  handleCloseMessage,
  handleShowMessage,
  user,
}) => {
  const [showImages, setShowImages] = useState(false);

  return (
    <>
      <div
        className={`business-card-modern ${
          isModal ? "col-12" : "col-lg-5 col-sm-12"
        }`}
      >
        <div
          className="px-3 pt-3 pb-2 d-flex justify-content-between align-items-center"
          style={{ borderBottom: "1px solid var(--border-light)" }}
        >
          <h6 className="fw-bold mb-0" style={{ color: "var(--text-primary)" }}>
            {businessName}
          </h6>
        </div>

        <div className="p-3">
          <button
            className="btn-ghost d-flex align-items-center gap-2 mb-3 w-100 justify-content-center"
            style={{ fontSize: "13px" }}
            onClick={() => setShowImages(!showImages)}
          >
            <ImageFill /> View Photos
          </button>

          <ul className="lh-lg px-0 mb-3" style={{ color: "var(--text-primary)" }}>
            <li className="d-flex align-items-start gap-2" style={{ fontSize: "14px" }}>
              <GeoAltFill className="mt-1 flex-shrink-0" style={{ color: "var(--accent)" }} />
              {`${address}, ${city}, ${state}`}
            </li>
            <li className="d-flex align-items-center gap-2" style={{ fontSize: "14px" }}>
              <EnvelopeAtFill className="flex-shrink-0" style={{ color: "var(--accent-secondary)" }} />
              {businessEmailAddress}
            </li>
            <li className="d-flex align-items-center gap-2" style={{ fontSize: "14px" }}>
              <TelephoneInboundFill className="flex-shrink-0" style={{ color: "var(--success-color)" }} />
              {phone}
            </li>
            <li className="d-flex align-items-center gap-2" style={{ fontSize: "14px" }}>
              <BriefcaseFill className="flex-shrink-0" style={{ color: "var(--warning-color)" }} />
              {businessCategory}
            </li>
            <li className="d-flex align-items-center gap-2" style={{ fontSize: "14px" }}>
              <StarFill className="flex-shrink-0" style={{ color: "var(--warning-color)" }} />
              {isNaN(ratingScore) ? "No ratings yet" : ratingScore}
            </li>
          </ul>

          {user && user.email !== businessEmailAddress && (
            <div className="d-flex gap-2">
              <button className="btn-accent flex-grow-1 d-flex align-items-center justify-content-center gap-2" style={{ fontSize: "13px" }} onClick={handleShowMessage}>
                <Send /> Message
              </button>
              <button className="btn-ghost flex-grow-1 d-flex align-items-center justify-content-center gap-2" style={{ fontSize: "13px" }} onClick={handleShow}>
                <Star /> Rate
              </button>
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <AddRatings
          show={showModal}
          businessEmail={grabEmail}
          handleClose={handleClose}
          user={user}
          secondParty={grabEmail}
        />
      )}
      {showMessageModal && (
        <AddMessage
          show={showMessageModal}
          businessEmail={grabEmail}
          businessName={businessName}
          handleClose={handleCloseMessage}
          user={user}
        />
      )}
      {showImages && (
        <DisplayImages
          show={showImages}
          handleClose={() => setShowImages(!showImages)}
          businessName={businessName}
          photo={photo}
          user={user}
        />
      )}
    </>
  );
};

export default BusinessCard;
